import { DatePipe, NgClass, NgFor, NgIf, NgStyle } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { SafeResourceUrlPipe } from "../../../pipes/safeResourceUrl/safe-resource-url.pipe";
import { AnimacionVideoComponent } from "../../animacion-video/animacion-video.component";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-fila-tres-columnas",
  templateUrl: "./fila-tres-columnas.component.html",
  styleUrls: ["./fila-tres-columnas.component.css"],
  imports: [NgClass, NgStyle, RouterLink, AnimacionVideoComponent, DatePipe, KebabCasePipe, SafeResourceUrlPipe, SkeletonImageComponent, NgIf, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilaTresColumnasComponent {
  @Input() noticias = [];
  @Input() descripcion;
  @Input() imagen;
  @Input() idStart: any;
  @Input() lcp: boolean;
  @Input() autorEmpresa;
  @Input() showFecha = true;

  formatDate(obj) {
    if (obj == null) {
      return null;
    }
    return obj.toString().replace(/\s/g, "T");
  }

  trackByNoticia(index: number, noticia: any): string {
    return noticia?.idVideo;
  }
}
